import { call, takeEvery } from 'redux-saga/effects';
import { WorkflowConstants } from 'constants/workflowConstants';
import { request } from 'components/Fetch';

function* checkinAction(action) {
  yield call(request({
    type: WorkflowConstants.CHECKIN_ACTION,
    method: 'POST',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* nextAction(action) {
  yield call(request({
    type: WorkflowConstants.NEXT_ACTION,
    method: 'PUT',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* checkPrviousAction(action) {
  yield call(request({
    type: WorkflowConstants.PREVIOUS_ACTION,
    method: 'PUT',
    url: action.payload.url,
  }), action);
}

function* getAdditionalSavingAmount(action) {
  yield call(request({
    type: WorkflowConstants.ADDTIONAL_SAVING_AMOUNT,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

export default function* () {
  yield takeEvery(WorkflowConstants.CHECKIN_ACTION, checkinAction);
  yield takeEvery(WorkflowConstants.NEXT_ACTION, nextAction);
  yield takeEvery(WorkflowConstants.PREVIOUS_ACTION, checkPrviousAction);
  yield takeEvery(WorkflowConstants.ADDTIONAL_SAVING_AMOUNT, getAdditionalSavingAmount);
}



// WEBPACK FOOTER //
// ./src/sagas/workflowSaga.js